import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { EndpointKey } from '../http/EndpointKey';
import { getIsActiveAndAssignedToVariantACQ129 } from '../store/experiments/selectors';
import { isEndpointStatusError } from '../store/http-responses/selectors';
import { Step } from '../views/Step';
import { PricingAlert } from './PricingAndTrial.styles';
export const PricingErrorAlert = () => {
  const isAcq129Variant = useSelector(getIsActiveAndAssignedToVariantACQ129);
  const {
    currentStep
  } = useCurrentStep();
  const isPricingEndpointError = useSelector(isEndpointStatusError(EndpointKey.PricingProducts) || isEndpointStatusError(EndpointKey.PricingPromotions));

  if (!isAcq129Variant || !isPricingEndpointError || currentStep !== Step.Pricing) {
    return null;
  }

  return /*#__PURE__*/_jsx(PricingAlert, {
    titleText: I18n.text(`views.${Step.Pricing}.errorBannerTitle`),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `views.${Step.Pricing}.errorBannerMessage`
    })
  });
};